import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "meal"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "images"
};
const _hoisted_4 = {
  class: "title"
};
import { ref, watch } from 'vue';
import CardHeader from './CardHeader.vue';
export default {
  __name: 'MonthHotMeal',
  props: {
    mealList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  setup(__props) {
    let props = __props;
    let dataList = ref();
    watch(() => props.mealList, newValue => {
      dataList.value = newValue || [];
    });
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(CardHeader, {
        title: "当月热门套餐"
      }), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataList), item => {
        return _openBlock(), _createElementBlock("div", {
          class: "item",
          key: item.id
        }, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.urlList, (url, index) => {
          return _openBlock(), _createBlock(_component_el_image, {
            key: index,
            class: "image",
            fit: "cover",
            src: url
          }, null, 8, ["src"]);
        }), 128))]), _createElementVNode("div", _hoisted_4, _toDisplayString(item.name), 1)]);
      }), 128))])]);
    };
  }
};